import css from './venue.module.scss';
import {VenueProps} from './venue.types';

export const Venue = (props: VenueProps): JSX.Element => {
	return (
		<div className={css.container}>
			<div className={css.content}>
				<div className={css.imageContainer}>
					<img src={props.img} />
				</div>
				<div className={css.detailsContainer}>
					<div className={css.date}>{props.date}</div>
					<div className={css.singer}>{props.singer}</div>
					<div className={css.place}>{props.place}</div>
					<div className={css.song}>{props.distance}</div>
				</div>
			</div>
		</div>
	);
};
